<template>
  <div>
    <point-toolbar />
    <v-card>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex
              xs12
              sm12
              md12
            >
              Профиль мощности
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import PointToolbar from '../points/PointToolbar'

export default {
  name: 'PointsScheduler',
  components: {
    PointToolbar
  },
  data () {
    return {
    }
  },
  computed: {
    pointFormTitle () {
      return this.editedIndex === -1 ? 'Новая точка учёта' : 'Редактирование точки учета'
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/spa/points/PointProfile.vue